import React, { useEffect, useState } from 'react';
import { resendSignUpCode } from 'aws-amplify/auth';
import PropTypes from 'prop-types';
import ErrorMessage from '../../ErrorMessage';
import { useRegisterContext } from '../RegisterContext';
import { MailIcon } from '../../../assets/icons';

function Step2({ isActive }) {
  const [error, setError] = useState();
  const [isResendDisabled, setResendDisabled] = useState();
  const { signUpUsername } = useRegisterContext();

  useEffect(() => {
    if (isActive) {
      setResendDisabled(true);
    }
  }, [isActive]);

  useEffect(() => {
    if (isResendDisabled) {
      setTimeout(() => {
        setResendDisabled(false);
      }, 60000);
    }
  }, [isResendDisabled]);

  const resendVerification = async () => {
    try {
      await resendSignUpCode({ username: signUpUsername });
      setResendDisabled(true);
      setError();
    } catch (err) {
      setError(err.message || err.name || 'Failed to resend code');
    }
  };

  return (
    <div className='px-6 py-9 sm:px-12 sm:py-11'>
      <div className='mb-5 text-center'>
        <MailIcon className='mx-auto h-16 w-16 text-[#0B1929]' strokeWidth='1.4' aria-hidden='true' />
      </div>
      <h3 className='font-serif text-2xl font-normal leading-tight text-[#0B1929]'>Check your inbox.</h3>
      <div className='mt-3 space-y-6'>
        <p className='text-sm leading-6 text-[#7A9AB0]'>
          To complete the registration, click on the link in your confirmation email. If you have not received an email, check your spam folder or
          request a new confirmation email.
        </p>

        <div className='flex items-start gap-3 rounded-[10px] bg-[#EBF4FB] px-4 py-3.5 text-[13.5px] leading-6 text-[#3D5A73]'>
          <MailIcon className='mt-1 h-4 w-4 shrink-0 text-[#2E6BAD]' />
          <span>
            Click the <b className='font-semibold text-[#0B1929]'>link in the email</b> to verify your account.
            {signUpUsername && (
              <>
                {' '}
                We sent it to <b className='font-semibold text-[#0B1929]'>{signUpUsername}</b>.
              </>
            )}{' '}
            Check your spam folder if you do not see it.
          </span>
        </div>

        <div className='text-center text-[13px] leading-6 text-[#7A9AB0]'>
          If you need a new confirmation email, you can request one below.
        </div>

        <button
          className='inline-flex h-12 w-full items-center justify-center rounded-full bg-[#0B1929] px-7 text-sm font-semibold text-white transition hover:bg-[#0F2540] disabled:cursor-not-allowed disabled:bg-[#B8C9D9]'
          onClick={resendVerification}
          disabled={isResendDisabled}
          type='button'
        >
          {isResendDisabled ? 'Confirmation email sent' : 'Request new confirmation email'}
        </button>
        {error && <ErrorMessage error={error} className='form-error-display' />}
      </div>
    </div>
  );
}

Step2.propTypes = {
  isActive: PropTypes.bool,
};

export default Step2;
